import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmWithReasonForm";
import {cancelVoidCharge} from "../../actions/SalesApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values, props) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

class VoidChargeFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("salesOrderId", this.props.salesOrderId)
    return this.props.voidCharge(updatedValues.toJS())
      .then((response) => {
        if (response.data.voidCharge.errors.length <= 0) {
          this.props.cancelVoidCharge();
        } else {
          let errors = createValidationErrors(response.data.voidCharge.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelVoidCharge();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        >
        <p><strong>Please note:</strong> Voiding the charge will result in the invoice being voided, but <em>any shipments or subscriptions will carry on</em> as if the order was paid.</p>
      </Form>
    )
  }
}

const CANCEL_SALES_ORDER = gql`
  mutation voidCharge($data: VoidChargeInput!) {
    voidCharge(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(CANCEL_SALES_ORDER, {
    props: ({ mutate }) => ({
      voidCharge: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelVoidCharge})(withMutation(VoidChargeFormContainer));